import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { qk } from '@/lib/queryKeys';
import { getNavigationForRole } from '@/lib/navigation';
import { useCurrentFarm } from './useCurrentFarm';
import { useMembership } from './useMembership';
import type { EditRequestCountResponse } from '@/types/edit-request';

export function useEditRequestCounts(farmId: string | null | undefined, enabled = true) {
  return useQuery({
    queryKey: qk.editRequests.counts(farmId),
    queryFn: () =>
      api.get<EditRequestCountResponse>(`/api/v1/farms/${farmId}/edit-requests/counts`),
    refetchInterval: 30000,
    enabled: !!farmId && enabled,
    // The global keepPreviousData would show the previous farm's count until the new one loads.
    placeholderData: undefined,
  });
}

/** Pending requests for the nav badge; 0 for roles that don't see Edit Requests. */
export function usePendingEditRequests(): number {
  const { role } = useMembership();
  const { farmId } = useCurrentFarm();
  const canReview = getNavigationForRole(role).some((item) => item.href === '/edit-requests');
  const { data } = useEditRequestCounts(farmId, canReview);
  return canReview ? (data?.data?.pending ?? 0) : 0;
}
